/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// TODO Unit testy.
/**
 * Poskytovatel zdrojů pro zobrazování PDF dokumentů.
 * @implements {ViewerSourceCreator}
 */
class PdfViewerSourceCreator {
  /**
   * Vytvoří instanci.
   * @param {number} max Maximální počet současně zobrazovaných PDF.
   * @param {PoolAsyncFactory} poolFactory
   * @param {PdfViewerSourceFactory} sourceFactory
   */
  constructor(max, poolFactory, sourceFactory) {
    this.pool = poolFactory.create(sourceFactory, { max });
    this.sourceFactory = sourceFactory;
  }

  /** @inheritdoc */
  delete(source) {
    return new Promise((resolve) => {
      source.getFrame().repair();
      const { pool } = this;
      return resolve(pool.delete(source));
    });
  }

  /** @inheritdoc */
  destroy() {
    // Prázdná metoda pro splnění rozhraní.
    // TODO #295 Zrevidovat rušení u ViewerSourceCreator?
  }

  /** @inheritdoc */
  getLent() {
    return this.pool.getLent();
  }

  /** @inheritdoc */
  getMax() {
    return this.pool.getMax();
  }

  /** @inheritdoc */
  lend(parentEl, scheduleInfo) {
    return new Promise((resolve) => {
      const { sourceFactory } = this;
      sourceFactory.setParentEl(parentEl);
      sourceFactory.setScheduleInfo(scheduleInfo);
      const source = this.pool.lend();
      return resolve(source);
    });
  }

  /** @inheritdoc */
  receive(source) {
    return new Promise((resolve) => resolve(this.pool.delete(source)));
  }

  /** @inheritdoc */
  replace() {
    return Promise.resolve();
  }
}

export default PdfViewerSourceCreator;
